import React from 'react'
import { config } from '../pages/config'
import { Link } from 'react-router-dom'

const ContactCta = () => {
    return (
        <section className=' my-5 pb-5'>
            <div className="auto-container p-md-5 p-4 bg-black2 overflow-hidden">
                <div className="sec-title light text-center">
                    <h2 className='mb-4 display-6' data-aos="fade-left">
                        Feel free to give us a call if you have any questions or if you'd like to confirm availability for a date that works for you.
                    </h2>

                    <div className="btn-box mt-5">
                        <Link to={`${config.appUrl}contact-us`}
                            className="theme-btn btn-one text-white">
                            Contact With Us
                        </Link>
                    </div>

                </div>
            </div>
        </section>
    )
}

export default ContactCta